module.exports = __webpack_public_path__ + "img/logo.0bd87ce7.svg";